
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexFOhgsmfL8iMeta } from "/app/pages/[id]/blog/[articleId]/index.vue?macro=true";
import { default as index2hyyRxG2G3Meta } from "/app/pages/[id]/blog/index.vue?macro=true";
import { default as indexeYTipyDheaMeta } from "/app/pages/[id]/communication/[code]/index.vue?macro=true";
import { default as indexJQ4UJPg9huMeta } from "/app/pages/[id]/index.vue?macro=true";
import { default as index3fG3pKjHjfMeta } from "/app/pages/[id]/qr/[vacancyListId]/index.vue?macro=true";
import { default as applyuwkckiVenzMeta } from "/app/pages/[id]/vacancies/[vacancyId]/apply.vue?macro=true";
import { default as indexTy7k8TwIrUMeta } from "/app/pages/[id]/vacancies/[vacancyId]/index.vue?macro=true";
import { default as interview1UrFeB6uq8Meta } from "/app/pages/[id]/vacancies/[vacancyId]/interview.vue?macro=true";
import { default as index2wEOb0h4XRMeta } from "/app/pages/[id]/vacancies/[vacancyId]/reply/[hash]/index.vue?macro=true";
import { default as indexgwQRkUZsF9Meta } from "/app/pages/[id]/vacancies/index.vue?macro=true";
import { default as _404STh7p7T7N0Meta } from "/app/pages/404.vue?macro=true";
import { default as indexWcjtCaXKWzMeta } from "/app/pages/blog/[articleId]/index.vue?macro=true";
import { default as indexgWaMlevJ7RMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as indexkNsBcfyCAyMeta } from "/app/pages/preview/[template_name]/[id]/blog/[articleId]/index.vue?macro=true";
import { default as indexCGQ8cJAKkqMeta } from "/app/pages/preview/[template_name]/[id]/blog/index.vue?macro=true";
import { default as index6WL07tfnoVMeta } from "/app/pages/preview/[template_name]/[id]/index.vue?macro=true";
import { default as index2qM2houMyMMeta } from "/app/pages/preview/[template_name]/[id]/qr/[vacancyListId]/index.vue?macro=true";
import { default as indexdLJapt6oW8Meta } from "/app/pages/preview/[template_name]/[id]/vacancies/[vacancyId]/index.vue?macro=true";
import { default as index1eNcsVn0EwMeta } from "/app/pages/preview/[template_name]/[id]/vacancies/index.vue?macro=true";
import { default as indexnF462H3jJqMeta } from "/app/pages/qr/[vacancyListId]/index.vue?macro=true";
import { default as index53aalFHEHiMeta } from "/app/pages/redacting/[template_name]/[id]/blog/[articleId]/index.vue?macro=true";
import { default as index3Wuq0FCxseMeta } from "/app/pages/redacting/[template_name]/[id]/blog/index.vue?macro=true";
import { default as indexvXiemEjHGHMeta } from "/app/pages/redacting/[template_name]/[id]/index.vue?macro=true";
import { default as indexRerIcoZN6YMeta } from "/app/pages/redacting/[template_name]/[id]/qr/[vacancyListId]/index.vue?macro=true";
import { default as indexTtEgHapKmRMeta } from "/app/pages/redacting/[template_name]/[id]/vacancies/[vacancyId]/index.vue?macro=true";
import { default as indexn2f0MCK51TMeta } from "/app/pages/redacting/[template_name]/[id]/vacancies/index.vue?macro=true";
import { default as applyreEztLV5erMeta } from "/app/pages/vacancies/[vacancyId]/apply.vue?macro=true";
import { default as index10w5iAT74bMeta } from "/app/pages/vacancies/[vacancyId]/index.vue?macro=true";
import { default as interviewDUsHpe1PSZMeta } from "/app/pages/vacancies/[vacancyId]/interview.vue?macro=true";
import { default as index2KEIpKJxEJMeta } from "/app/pages/vacancies/[vacancyId]/reply/[hash]/index.vue?macro=true";
import { default as indexFUXDj6FeuaMeta } from "/app/pages/vacancies/index.vue?macro=true";
export default [
  {
    name: "id-blog-articleId",
    path: "/:id()/blog/:articleId()",
    component: () => import("/app/pages/[id]/blog/[articleId]/index.vue")
  },
  {
    name: "id-blog",
    path: "/:id()/blog",
    component: () => import("/app/pages/[id]/blog/index.vue")
  },
  {
    name: "id-communication-code",
    path: "/:id()/communication/:code()",
    component: () => import("/app/pages/[id]/communication/[code]/index.vue")
  },
  {
    name: "id",
    path: "/:id()",
    component: () => import("/app/pages/[id]/index.vue")
  },
  {
    name: "id-qr-vacancyListId",
    path: "/:id()/qr/:vacancyListId()",
    component: () => import("/app/pages/[id]/qr/[vacancyListId]/index.vue")
  },
  {
    name: "id-vacancies-vacancyId-apply",
    path: "/:id()/vacancies/:vacancyId()/apply",
    component: () => import("/app/pages/[id]/vacancies/[vacancyId]/apply.vue")
  },
  {
    name: "id-vacancies-vacancyId",
    path: "/:id()/vacancies/:vacancyId()",
    component: () => import("/app/pages/[id]/vacancies/[vacancyId]/index.vue")
  },
  {
    name: "id-vacancies-vacancyId-interview",
    path: "/:id()/vacancies/:vacancyId()/interview",
    component: () => import("/app/pages/[id]/vacancies/[vacancyId]/interview.vue")
  },
  {
    name: "id-vacancies-vacancyId-reply-hash",
    path: "/:id()/vacancies/:vacancyId()/reply/:hash()",
    component: () => import("/app/pages/[id]/vacancies/[vacancyId]/reply/[hash]/index.vue")
  },
  {
    name: "id-vacancies",
    path: "/:id()/vacancies",
    component: () => import("/app/pages/[id]/vacancies/index.vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/app/pages/404.vue")
  },
  {
    name: "blog-articleId",
    path: "/blog/:articleId()",
    component: () => import("/app/pages/blog/[articleId]/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "preview-template_name-id-blog-articleId",
    path: "/preview/:template_name()/:id()/blog/:articleId()",
    component: () => import("/app/pages/preview/[template_name]/[id]/blog/[articleId]/index.vue")
  },
  {
    name: "preview-template_name-id-blog",
    path: "/preview/:template_name()/:id()/blog",
    component: () => import("/app/pages/preview/[template_name]/[id]/blog/index.vue")
  },
  {
    name: "preview-template_name-id",
    path: "/preview/:template_name()/:id()",
    component: () => import("/app/pages/preview/[template_name]/[id]/index.vue")
  },
  {
    name: "preview-template_name-id-qr-vacancyListId",
    path: "/preview/:template_name()/:id()/qr/:vacancyListId()",
    component: () => import("/app/pages/preview/[template_name]/[id]/qr/[vacancyListId]/index.vue")
  },
  {
    name: "preview-template_name-id-vacancies-vacancyId",
    path: "/preview/:template_name()/:id()/vacancies/:vacancyId()",
    component: () => import("/app/pages/preview/[template_name]/[id]/vacancies/[vacancyId]/index.vue")
  },
  {
    name: "preview-template_name-id-vacancies",
    path: "/preview/:template_name()/:id()/vacancies",
    component: () => import("/app/pages/preview/[template_name]/[id]/vacancies/index.vue")
  },
  {
    name: "qr-vacancyListId",
    path: "/qr/:vacancyListId()",
    component: () => import("/app/pages/qr/[vacancyListId]/index.vue")
  },
  {
    name: "redacting-template_name-id-blog-articleId",
    path: "/redacting/:template_name()/:id()/blog/:articleId()",
    component: () => import("/app/pages/redacting/[template_name]/[id]/blog/[articleId]/index.vue")
  },
  {
    name: "redacting-template_name-id-blog",
    path: "/redacting/:template_name()/:id()/blog",
    component: () => import("/app/pages/redacting/[template_name]/[id]/blog/index.vue")
  },
  {
    name: "redacting-template_name-id",
    path: "/redacting/:template_name()/:id()",
    component: () => import("/app/pages/redacting/[template_name]/[id]/index.vue")
  },
  {
    name: "redacting-template_name-id-qr-vacancyListId",
    path: "/redacting/:template_name()/:id()/qr/:vacancyListId()",
    component: () => import("/app/pages/redacting/[template_name]/[id]/qr/[vacancyListId]/index.vue")
  },
  {
    name: "redacting-template_name-id-vacancies-vacancyId",
    path: "/redacting/:template_name()/:id()/vacancies/:vacancyId()",
    component: () => import("/app/pages/redacting/[template_name]/[id]/vacancies/[vacancyId]/index.vue")
  },
  {
    name: "redacting-template_name-id-vacancies",
    path: "/redacting/:template_name()/:id()/vacancies",
    component: () => import("/app/pages/redacting/[template_name]/[id]/vacancies/index.vue")
  },
  {
    name: "vacancies-vacancyId-apply",
    path: "/vacancies/:vacancyId()/apply",
    component: () => import("/app/pages/vacancies/[vacancyId]/apply.vue")
  },
  {
    name: "vacancies-vacancyId",
    path: "/vacancies/:vacancyId()",
    component: () => import("/app/pages/vacancies/[vacancyId]/index.vue")
  },
  {
    name: "vacancies-vacancyId-interview",
    path: "/vacancies/:vacancyId()/interview",
    component: () => import("/app/pages/vacancies/[vacancyId]/interview.vue")
  },
  {
    name: "vacancies-vacancyId-reply-hash",
    path: "/vacancies/:vacancyId()/reply/:hash()",
    component: () => import("/app/pages/vacancies/[vacancyId]/reply/[hash]/index.vue")
  },
  {
    name: "vacancies",
    path: "/vacancies",
    component: () => import("/app/pages/vacancies/index.vue")
  }
]